import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as userGroupService from "../../services/userGroupService";
import { handleApiError } from "../storeEffects";
import { UserGroupAction, userGroupFailure, userGroupSuccess } from "./storeUserGroup";

export type UserGroupThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, UserGroupAction>

export const getUserGroupPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return userGroupService.getUserGroupPage()
        .then(
            userGroupPage => {
                dispatch(userGroupSuccess(userGroupPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(userGroupFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};
